/**
 * imageFilter — v1.12.977
 *
 * Garde-fou central « pas d'image = pas affiché ».
 * Certains articles partenaires (ex. Coutr) arrivent sans visuel exploitable
 * dans le catalogue → ils ne doivent apparaître NULLE PART (catalogue,
 * sélection styliste, créer un look, compléter un look).
 */

// v1.13.26 — Partenaires masqués (sur demande) : leurs articles ne doivent
// apparaître NULLE PART. Identifiés par l'hôte de l'image.
//   - Zalando : *.ztat.net
//   - H&M     : *.hm.com
//   - Mango   : *.mngbcn.com
import { isImageDead } from './deadImages';

const BLOCKED_IMAGE_HOSTS = ['ztat.net', 'hm.com', 'mngbcn.com'];
export function isBlockedPartnerImage(item) {
  try {
    const u = typeof item === 'string'
      ? item
      : (item?.image || item?.image_url || item?.photoUrl || item?.imageUrl || '');
    if (!u || typeof u !== 'string') return false;
    const host = ((u.match(/^https?:\/\/([^/]+)/i) || [])[1] || '').toLowerCase();
    if (!host) return false;
    return BLOCKED_IMAGE_HOSTS.some(b => host === b || host.endsWith('.' + b));
  } catch { return false; }
}

// Un article a-t-il une image exploitable ? (couvre les différents noms de champ
// selon la source : catalogue outfit-api, looks API, suggestions complete-look)
// v1.13.26 — exclut aussi les partenaires masqués (Zalando/H&M/Mango) → filtre
// universel : tout consumer qui passe par hasUsableImage les cache automatiquement.
export function hasUsableImage(item) {
  if (!item || typeof item !== 'object') return false;
  const img = item.image || item.image_url || item.photoUrl || item.imageUrl || '';
  if (typeof img !== 'string') return false;
  const v = img.trim().toLowerCase();
  if (v === '' || v === 'null' || v === 'undefined') return false;
  if (isBlockedPartnerImage(img)) return false;
  // v1.13.43 — Lien mort partenaire (404 confirmé après tous les proxies) →
  // masqué partout (catalogue, sélection styliste, looks).
  if (isImageDead(img)) return false;
  return true;
}

// Filtre un tableau d'articles : ne garde que ceux avec image exploitable.
export function filterItemsWithImages(items) {
  if (!Array.isArray(items)) return items;
  return items.filter(hasUsableImage);
}
